import { render } from "./BudgetItemsEditor.vue?vue&type=template&id=6e7a2a8e"
import script from "./BudgetItemsEditor.vue?vue&type=script&lang=js"
export * from "./BudgetItemsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__